export default "__VITE_ASSET__2b77801e__"